/**
 * Cancel Action - WHAT Section
 *
 * Edit mode UI for cancelling a user client.
 * When triggered, transitions to inactive and removes from groups.
 *
 * V2 Reference: v2/app/templates/components/client-reminder-cancel.hbs
 *
 * This action has no editable "what" section - the behavior is fixed:
 * - Transition to Inactive client
 * - Remove from all groups
 *
 * The trigger determines WHEN this happens (cancel_subscription or expired_package)
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Typography } from 'src/components/Typography';

import { ActionWhatSectionProps } from '../automationActions';

/**
 * Cancel WHAT Section - Edit mode
 *
 * This action has fixed behavior - no configuration needed.
 */
export const CancelWhatSection: FC<ActionWhatSectionProps> = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography color="text.secondary" fontStyle="italic">
        {t('automations.cancel.ifNoSubscriptions')}
      </Typography>
      <Box component="ol" sx={{ mt: 1, pl: 3 }}>
        <li>{t('automations.cancel.transitionToInactive')}</li>
        <li>{t('automations.cancel.removeFromGroups')}</li>
      </Box>
    </Box>
  );
};

/**
 * Cancel What Summary Component
 */
export const CancelWhatSummary: FC<{
  automation: ActionWhatSectionProps['automation'];
}> = () => {
  const { t } = useTranslation();
  return <>{t('automations.cancel.summary')}</>;
};
